import { render, staticRenderFns } from "./TimerEntradasComponent.vue?vue&type=template&id=2455c6dc&scoped=true"
import script from "./TimerEntradasComponent.vue?vue&type=script&lang=js"
export * from "./TimerEntradasComponent.vue?vue&type=script&lang=js"
import style0 from "./TimerEntradasComponent.vue?vue&type=style&index=0&id=2455c6dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2455c6dc",
  null
  
)

export default component.exports